import React from 'react';
import { View } from 'react-native';

import Text from '../../../components/text/Text';
import { TextInputEditInPlace } from '../../../components/input';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

const SetupTextField = ({
	label,
	value,
	onConfirm,
	field,
	placeholder = 'Not set',
	multiline,
	numberOfLines = 4,
	disabled = false,
	hint,
	required = false,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.container}>
			<Text style={styles.label}>
				{label}
				{required && <Text style={styles.required}> *</Text>}
			</Text>
			<TextInputEditInPlace
				value={value}
				field={field}
				placeholder={placeholder}
				onConfirm={onConfirm}
				multiline={multiline}
				numberOfLines={multiline ? numberOfLines : undefined}
				style={multiline ? styles.multiline : undefined}
				disabled={disabled}
			/>
			{hint && <Text style={styles.hint}>{hint}</Text>}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		marginBottom: space.lg,
	},
	label: {
		...type.fieldLabel,
		color: colors.text,
		marginBottom: 6,
	},
	required: {
		color: colors.danger,
	},
	multiline: {
		minHeight: 100,
		textAlignVertical: 'top',
	},
	hint: {
		...type.secondary,
		color: colors.textSecondary,
		marginTop: space.xs,
	},
});

export default SetupTextField;
